import { create } from 'zustand';

type RefState = {
    ref: HTMLDivElement | null;
};

export const useRootContainerReferenceStore = create<RefState>(() => ({ ref: null }));
